module.exports = __webpack_public_path__ + "img/dead-dry-hairy-tree-11.07bf368a.png";